import styled from "styled-components"

export const Body = styled.div`
  position: relative;
`
